import {EVENTS_LOG} from "../../Config/ApiUrl";
// import AttendanceHelperMixin from "./AttendanceHelperMixin";
// import {DepartmentFilterMixin, UserFilterMixin, WorkingShiftFilterMixin} from "./FilterMixin";

export default {
    mixins: [],
    data() {
        return {
            options: {
                name: this.$t('event_list'),                    
                url: EVENTS_LOG,
                showHeader: true,
                showCount: true,
                showClearFilter: true,
                tableData: 0,
                afterRequestSuccess: ({data}) => {
                    this.tableData = data.data.length;
                },
                columns: [
                    {
                        title: this.$t('title'),
                        type: 'text',
                        key: 'title',
                        isVisible: true,
                    },
                    {
                        title: this.$t('category'),
                        type: 'text',
                        key: 'category',
                        isVisible: true,
                    },
                    {
                        title: this.$t('date'),
                        type: 'text',
                        key: 'event_date',
                        isVisible: true,
                    },
                    {
                        title: this.$t('start_time'),
                        type: 'text',
                        key: 'start_time',
                        isVisible: true,
                    },
                    {
                        title: this.$t('end_time'),
                        type: 'text',
                        key: 'end_time',
                        isVisible: true,
                    },
                    {
                        title: this.$t('actions'),
                        type: 'action',
                        isVisible: true
                    }
                ],
                filters: [
                    {
                        type: 'date-range-filter',
                        title: this.$t('date_range'),
                        key: 'date_range',
                        option: []
                    }
                ],
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                showAction: true,
                orderBy: 'desc',
                actionType: "dropdown",
                actions: [
                    {
                        title: this.$t('edit'),
                        icon: 'edit',
                        type: 'edit',
                        url: '',
                        modifier: (row) => row.id
                    },
                    {
                        title: this.$t('delete'),
                        icon: 'trash',
                        type: 'delete',
                        url: '',
                        modifier: (row) => row.id
                    }
                ],
            }
        }
    }
}